export default "__VITE_ASSET__DMNHRY1T__"